import { render } from "./searchPage.vue?vue&type=template&id=436bb722&scoped=true"
import script from "./searchPage.vue?vue&type=script&lang=js"
export * from "./searchPage.vue?vue&type=script&lang=js"

import "./searchPage.vue?vue&type=style&index=0&id=436bb722&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-436bb722"]])

export default __exports__